export const QUERY_PARAMETERS = {
  CLIENT_ID: 'client_id',
  REDIRECT_URI: 'redirect_uri',
  RESPONSE_TYPE: 'response_type',
  LOCALE: 'locale',
  STATE: 'state',
  COUNTRY_CODE: 'countryCode'
} as const
